// extracted by mini-css-extract-plugin
module.exports = {"input":"Registration_input__3yThw","link":"Registration_link__2rWB5","withPaddingBottom":"Registration_withPaddingBottom__2C76u","anchor":"Registration_anchor__MqSPH"};